module.exports = "/_next/static/images/0167659c4d47279ed65559769be3801a-pj-phone-and-business-card@0.75x.jpg";